module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    staticClass: "ql-cue-list",
    attrs: {
      "md-column": ""
    }
  }, [(!_vm.cues.length) ? _c('p', {
    staticClass: "md-body-2"
  }, [_vm._v("You haven't created any cues on this page. Select text or right click on the document to add a cue.")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.cues), function(cue) {
    return _c('project-cues-cue', {
      key: cue.id,
      attrs: {
        "cue": cue,
        "open": _vm.isOpen(cue),
        "layers": _vm.layers,
        "locked": _vm.locked
      },
      on: {
        "openCue": function($event) {
          _vm.openCue(cue)
        },
        "closeCue": function($event) {
          _vm.closeCue(cue)
        },
        "destroy": _vm.destroy,
        "updatedCue": _vm.updatedCue
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fbfb811","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/project/cues/cue-list.vue
// module id = 664
// module chunks = 2